export function getReleaseFromBaseUrl(baseUrl, options) {
    if (options === void 0) { options = {}; }
    var _a = options.artifactName, artifactName = _a === void 0 ? false : _a, _b = options.separator, separator = _b === void 0 ? '@' : _b;
    var isLocal = baseUrl.includes('localhost');
    if (isLocal) {
        return;
    }
    var pathFragments = baseUrl.split('/');
    var artifactNamePart = artifactName && pathFragments[pathFragments.length - 3];
    var versionStr = pathFragments[pathFragments.length - 2];
    return [artifactNamePart, versionStr].filter(Boolean).join(separator);
}
//# sourceMappingURL=getReleaseFromBaseUrl.js.map